import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { useLang } from "@/context/LangContext";
import { getSiteLang } from "@/lib/site";

const OrderCtx = createContext(null);
const KEY = "minaqu-order-list";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const OrderProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (p) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === p.id);
      if (found) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price || "", img: p.img, qty: 1 }];
    });
    toast.success(t(`${p.name} ditambahkan ke daftar pesanan`, `${p.name} added to your order list`));
  };
  const setQty = (id, qty) =>
    setItems((prev) => (qty < 1 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <OrderCtx.Provider value={{ items, add, setQty, clear, count, open, setOpen }}>{children}</OrderCtx.Provider>
  );
};

export const useOrder = () => useContext(OrderCtx);

export const orderMessage = (items, extra = "") => {
  const en = getSiteLang() === "en";
  const lines = items.map((i, n) => `${n + 1}. ${i.name} x${i.qty}${i.price ? ` (${i.price})` : ""}`);
  return `${en ? "Hello Minaqu Indonesia, I would like to order:" : "Halo Minaqu Indonesia, saya ingin memesan:"}\n${lines.join("\n")}${extra ? `\n\n${extra}` : ""}`;
};
